document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', async (event) => {
    const paymentButton = event.target.closest('.shopify-payment-button__button');

    if (!paymentButton) return;

    const productForm = paymentButton.closest('product-form');

    if (!productForm) return;

    const form = productForm.querySelector('form[data-type="add-to-cart-form"]');

    if (!form) return;

    // Evitamos que Shopify nos mande directamente al checkout
    event.preventDefault();
    event.stopPropagation();

    const variantInput = form.querySelector('input[name="id"]');
    const quantityInput = form.querySelector('input[name="quantity"]');

    if (!variantInput || !variantInput.value) {
      console.error('No se encontró la variante del producto.');
      return;
    }

    const variantId = Number(variantInput.value);
    const quantity = quantityInput ? Number(quantityInput.value) || 1 : 1;

    try {
      paymentButton.setAttribute('aria-disabled', 'true');

      const response = await fetch(
        window.Shopify.routes.root + 'cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: quantity
              }
            ]
          })
        }
      );

      if (!response.ok) {
        throw new Error('No se pudo agregar el producto al carrito.');
      }

      // Después de agregarlo, vamos al carrito
      window.location.href = window.Shopify.routes.root + 'cart';

    } catch (error) {
      console.error('Error al agregar al carrito:', error);
      paymentButton.removeAttribute('aria-disabled');
    }
  }, true);
});